import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select/Select';
import { ParameterProps } from './parameterSelector';
import i18n from '../../../../locales/i18n';

type Props = ParameterProps & {
  parameter: string;
  range: string[];
  range_names: string[]
  range_names_de: string[];
  range_names_en: string[];
};

const EnumParameter = ({ name, name_de, name_en, range, range_names: rangeNames, range_names_de: rangeNamesDE, range_names_en: rangeNamesEN, selected, onChange }: Props): JSX.Element => {
  const handleChange = (e: SelectChangeEvent<string>) => onChange(e.target.value as string);
  const currentLanguage = i18n.language;
  const parameterName: string = (currentLanguage === 'de' && name_de !== undefined) ? name_de : 
  ((currentLanguage === 'en' && name_en !== undefined ) ? (name_en) : (name !== undefined ? (name) : ("")));

  const menuItems: string[] = (currentLanguage === 'de' && rangeNamesDE !== undefined) ? rangeNamesDE : 
  ((currentLanguage === 'en' && rangeNamesEN !== undefined ) ? (rangeNamesEN) : (rangeNames));


  return (
    <FormControl fullWidth variant={'filled'}>
      <InputLabel id={`enum-param-${parameterName}`}>{parameterName}</InputLabel>
      <Select label={parameterName} labelId={`enum-param-${parameterName}`} value={(selected ?? '') as string} onChange={handleChange}>
        {range.map((e, i) => (
          <MenuItem key={i} value={e}>
            {menuItems[i]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default EnumParameter;
